<template>
  <form v-if="entity" class="row" @submit.prevent="onSave({close: false})">
    <div class="col">
      <!--      <form-input :label="$t('name')"-->
      <!--                  :placeholder="$t('Max Muster')"-->
      <!--                  v-model="entity.name"-->
      <!--      />-->
      <!--      <form-input :label="$t('company name')"-->
      <!--                  v-model="entity.company"-->
      <!--      />-->
      <!--      <form-input :label="$t('title')"-->
      <!--                  v-model="entity.title"-->
      <!--      />-->
      <!--      <form-textarea :label="$t('description')"-->
      <!--                     v-model="entity.description"-->
      <!--      />-->
      <form-model-controls :docs="actionDocs" v-model="entity"/>

    </div>
    <div class="col-5">

      <label>{{ $t('userimage') }}</label>
      <form-file-upload accept=".jpg,.jpeg,.gif,.png" @input="entity.files.push($event)">
        <ul>
          <li>{{ $t('Dateigröße nicht mehr als 10 MB') }}</li>
          <li>{{ $t('Bilder nicht kleiner als 100x100 px') }}</li>
          <li>{{ $t('Bitte beachten Sie das geltende Urheberrecht') }}</li>
        </ul>
      </form-file-upload>
      <form-file-order v-model="entity.files"/>
    </div>
    <div class="col-12 py-5">

      <bottom-tool-bar :can-delete="!!speakerId" @save="onSave" @delete="onDelete"/>
    </div>
    <confirmation-modal v-if="showDirtyModal"
                        :title="$t('Achtung')"
                        @close="cancelNavigation">
      <template v-slot:default>
        {{ $t('Sie haben ungespeicherte Änderungen. Wie wollen Sie fortfahren?') }}
      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-danger" @click="dontSave">
          {{ $t('Nicht speichern') }}
        </button>
        <button type="button" class="btn btn-primary" @click="onSave({close:true})">
          {{ $t('Speichern') }}
        </button>
      </template>
    </confirmation-modal>
  </form>
</template>

<script>
import {mapActions} from "vuex";
// Mixins
import ViewDirtyMixin from '@/mixins/view-dirty'
// Components
import FormFileUpload from "@/components/Form/FormFileUpload";
import FormFileOrder from "@/components/Form/FormFileOrder";
import FormInput from "@/components/Form/FormInput";
import FormTextarea from "@/components/Form/FormTextarea";
import ConfirmationModal from "@/components/ConfirmationModal";
import FormModelControls from "@/components/Form/FormModelControls";
import BottomToolBar from "@/components/BottomToolBar";

export default {
  name: "SpeakerForm",
  mixins: [ViewDirtyMixin],
  components: {
    BottomToolBar,
    FormModelControls, ConfirmationModal, FormTextarea, FormInput, FormFileOrder, FormFileUpload
  },
  props: {
    regionId: {type: String, default: null},
    speakerId: {type: String, default: null},
  },
  data() {
    return {
      entity: null
    }
  },
  computed: {
    actionDocs() {
      if (this.speakerId) {
        return this.$apiData.Speakers.find(action => action.name === 'modify')
      }

      return this.$apiData.Speakers.find(action => action.name === 'add')
    }
  },
  created() {
    if (this.speakerId) {
      this.getSpeaker({id: this.speakerId})
          .then(speaker => this.entity = speaker)
          .catch(this.apiErrorHandler)
    } else {
      this.entity = {
        region_id: this.regionId,
        name: '',
        company: '',
        title: '',
        description: '',
        files: [],
      }
    }
  },
  methods: {
    ...mapActions({
      addSpeaker: "Api/Speakers/add",
      getSpeaker: "Api/Speakers/get",
      modifySpeaker: "Api/Speakers/modify",
      deleteSpeaker: "Api/Speakers/delete",
    }),
    onSave({close}) {
      if (this.speakerId) {
        this.modifySpeaker(this.entity)
            .then(close ? this.saveComplete : this.saveCompleteToast)
            .catch(this.apiErrorHandler);
      } else {
        this.addSpeaker(this.entity)
            .then(close ? this.saveComplete : entity => {
              this.entity = entity;
              this.saveCompleteToast();
              this.$router.replace(['/regions', this.regionId, 'speakers/edit', entity.id].join('/'))
            })
            .catch(this.apiErrorHandler);
      }
    },
    onDelete() {
      this.deleteSpeaker({id: this.speakerId})
          .then(this.saveComplete)
          .catch(this.apiErrorHandler);
    }
  }
}
</script>
